import {Component, Input} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {LookupService} from "../../srvs/lookup";
import {Observable, Subscription} from "rxjs";

@Component({
  selector: 'micro-saUser',
  templateUrl: './saUser-detail.component.html'
})
export class SaUserDetailComponent extends BaseComponent {

  @Input()
  userId:any;

  saUser:any;
  userCategoryIds:string[];
  userRegionIds:string[];
  allAccessCategories:any[];
  allRegions:any[];
  hasSiteAccess:boolean;
  siteAccessGranted:boolean;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private lookupService:LookupService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    if (this.userId) {
      this.loadId(this.userId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id !== '0') {
            this.userId = id;
            this.loadId(id);
            this.loadRegions(id);
            this.loadAccessCategories(id);
          }
        });
    }
  }

  loadId(id) {

    this.http.get(`${this.env.e.url}/access/saContacts/users/${id}`).subscribe(
      data => {
        this.setSaUser(data);
      },
      error => {
        this.alertService.warn(error);
      }
    );
  }

  save() {
    // first set service
    let restCall: Observable<any> = undefined;
    var httpParams:HttpParams = new HttpParams()
      .set("service", "SITE_ACCESS");
    if (!this.hasSiteAccess && this.siteAccessGranted) {
      restCall = this.http.post(`${this.env.e.url}/access/saContacts/users/addService`, [this.saUser.id], {params: httpParams});
    } else if (this.hasSiteAccess && !this.siteAccessGranted) {
      restCall = this.http.post(`${this.env.e.url}/access/saContacts/users/removeService`, [this.saUser.id],{params: httpParams});
    }

    if (restCall) {
      restCall.subscribe(
        data => {
          this.hasSiteAccess = this.siteAccessGranted;
          if (this.hasSiteAccess) {
            if (!this.saUser.services.includes("SITE_ACCESS")) {
              this.saUser.services.push("SITE_ACCESS");
            }
          } else {
            this.saUser.services = this.saUser.services.filter(s => s !== "SITE_ACCESS");
          }
          this.saveRegions();
        },
        error => {
          this.siteAccessGranted = !this.siteAccessGranted
          this.alertService.warn(error);
        }
      );
    } else {
      this.saveRegions();
    }
  }

  saveRegions() {
    let restCall: Observable<any> = undefined;
    restCall = this.http.put(`${this.env.e.url}/domain/regions/users/${this.saUser.id}`, this.userRegionIds);

    if (restCall) {
      restCall.subscribe(
        data => {
          this.saUser.regionIds = data as any[];
          this.userRegionIds = this.saUser.regionIds;
          this.saveAccessCategories();
        },
        error => {
          this.alertService.warn(error);
        }
      );
    }
  }

  saveAccessCategories() {
    let restCall: Observable<any> = undefined;
    restCall = this.http.post(`${this.env.e.url}/access/categories/users/${this.saUser.id}`, this.userCategoryIds);

    if (restCall) {
      restCall.subscribe(
        data => {
          this.userCategoryIds = data as any[];
          this.alertService.info(`Updated ${this.saUser.username}`)
        },
        error => {
          this.alertService.warn(error);
        }
      );
    }
  }


  loadRegions(userId: string = undefined) {
    if (!userId && !this.userId) return;

    var params:HttpParams = new HttpParams()
      .set("userId", userId ?? this.userId);
    this.http.get(`${this.env.e.url}/domain/regions/findRegionsForUserId`,  {params: params}).subscribe(
      data => {
        this.allRegions = data as any[];
      }
    );
  }

  loadAccessCategories(userId: string = undefined) {
    if (!userId && !this.userId) return;

    this.http.get(`${this.env.e.url}/access/categories/users/${userId ?? this.userId}`).subscribe(
      data => {
        let retData = data as any;
        this.userCategoryIds = retData.assignedIds;
        this.allAccessCategories = retData.all.filter(ac => ac.id !== 'default');
      }
    );
  }

  setSaUser(saUser:any, loadSites = true) {
    this.saUser = saUser;
    this.userRegionIds = saUser.regionIds;
    this.hasSiteAccess = saUser.services.includes("SITE_ACCESS");
    this.siteAccessGranted = this.hasSiteAccess;
  }


  protected revokeSecureAccess() {
    this.saUser.services = this.saUser.services.filter(s => s !== "SITE_ACCESS");
    // this.hasSiteAccess = false;
    this.siteAccessGranted = false;
    this.save();
  }

  protected enableSecureAccess() {

    // this.hasSiteAccess = true;
    this.siteAccessGranted = true;
    this.save();
  }
}
